// AUTO-GENERATED GraphQL Builder for Offering
import * as Builders from '../';
export class OfferingBuilder {
  private s:string[]=[]; private r:string[]=[]; private v=new Set<string>(); depth=0;
  private add(f:string){ if(!this.s.includes(f)) this.s.push(f); return this; }
  getSelections(){ return [...this.s]; }
  toSelectionSet(){ const a=[...this.s,...this.r]; if(!a.length)return`{ id }`; return`{\n  ${a.join("\n  ")}\n}`;}
  guid(){ return this.add('guid'); }
  vendorId(){ return this.add('vendorId'); }
  serviceCategoryId(){ return this.add('serviceCategoryId'); }
  name(){ return this.add('name'); }
  description(){ return this.add('description'); }
  basePrice(){ return this.add('basePrice'); }
  pricingUnit(){ return this.add('pricingUnit'); }
  minPax(){ return this.add('minPax'); }
  maxPax(){ return this.add('maxPax'); }
  status(){ return this.add('status'); }
  maxTables(){ return this.add('maxTables'); }
  hallMode(){ return this.add('hallMode'); }
  showFacilities(){ return this.add('showFacilities'); }
  pricingMode(){ return this.add('pricingMode'); }
  id(){ return this.add('id'); }
  isDeleted(){ return this.add('isDeleted'); }
  createdBy(){ return this.add('createdBy'); }
  createdDate(){ return this.add('createdDate'); }
  updatedBy(){ return this.add('updatedBy'); }
  updatedDate(){ return this.add('updatedDate'); }

  createdByUser(b?:(q:Builders.UserBuilder)=>void){
    if(this.depth>=5||this.v.has('createdByUser'))return this;
    this.v.add('createdByUser');
    const n=new Builders.UserBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`createdByUser { ${inner} }`);
    return this;
  }

  serviceCategory(b?:(q:Builders.ServiceCategoryBuilder)=>void){
    if(this.depth>=5||this.v.has('serviceCategory'))return this;
    this.v.add('serviceCategory');
    const n=new Builders.ServiceCategoryBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`serviceCategory { ${inner} }`);
    return this;
  }

  updatedByUser(b?:(q:Builders.UserBuilder)=>void){
    if(this.depth>=5||this.v.has('updatedByUser'))return this;
    this.v.add('updatedByUser');
    const n=new Builders.UserBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`updatedByUser { ${inner} }`);
    return this;
  }

  vendor(b?:(q:Builders.VendorBuilder)=>void){
    if(this.depth>=5||this.v.has('vendor'))return this;
    this.v.add('vendor');
    const n=new Builders.VendorBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`vendor { ${inner} }`);
    return this;
  }

  blockedDateList(b?:(q:Builders.BlockedDateBuilder)=>void){
    if(this.depth>=5||this.v.has('blockedDateList'))return this;
    this.v.add('blockedDateList');
    const n=new Builders.BlockedDateBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`blockedDateList { ${inner} }`);
    return this;
  }

  bookingList(b?:(q:Builders.BookingBuilder)=>void){
    if(this.depth>=5||this.v.has('bookingList'))return this;
    this.v.add('bookingList');
    const n=new Builders.BookingBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`bookingList { ${inner} }`);
    return this;
  }

  bookingChangeProposalList(b?:(q:Builders.BookingChangeProposalBuilder)=>void){
    if(this.depth>=5||this.v.has('bookingChangeProposalList'))return this;
    this.v.add('bookingChangeProposalList');
    const n=new Builders.BookingChangeProposalBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`bookingChangeProposalList { ${inner} }`);
    return this;
  }

  bookingPackageByBundleOfferingList(b?:(q:Builders.BookingPackageBuilder)=>void){
    if(this.depth>=5||this.v.has('bookingPackageByBundleOfferingList'))return this;
    this.v.add('bookingPackageByBundleOfferingList');
    const n=new Builders.BookingPackageBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`bookingPackageByBundleOfferingList { ${inner} }`);
    return this;
  }

  bookingPackageByOfferingList(b?:(q:Builders.BookingPackageBuilder)=>void){
    if(this.depth>=5||this.v.has('bookingPackageByOfferingList'))return this;
    this.v.add('bookingPackageByOfferingList');
    const n=new Builders.BookingPackageBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`bookingPackageByOfferingList { ${inner} }`);
    return this;
  }

  bookingPartnerChangeList(b?:(q:Builders.BookingPartnerChangeBuilder)=>void){
    if(this.depth>=5||this.v.has('bookingPartnerChangeList'))return this;
    this.v.add('bookingPartnerChangeList');
    const n=new Builders.BookingPartnerChangeBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`bookingPartnerChangeList { ${inner} }`);
    return this;
  }

  menuCourseList(b?:(q:Builders.MenuCourseBuilder)=>void){
    if(this.depth>=5||this.v.has('menuCourseList'))return this;
    this.v.add('menuCourseList');
    const n=new Builders.MenuCourseBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`menuCourseList { ${inner} }`);
    return this;
  }

  offeringAddonList(b?:(q:Builders.OfferingAddonBuilder)=>void){
    if(this.depth>=5||this.v.has('offeringAddonList'))return this;
    this.v.add('offeringAddonList');
    const n=new Builders.OfferingAddonBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`offeringAddonList { ${inner} }`);
    return this;
  }

  offeringFacilityList(b?:(q:Builders.OfferingFacilityBuilder)=>void){
    if(this.depth>=5||this.v.has('offeringFacilityList'))return this;
    this.v.add('offeringFacilityList');
    const n=new Builders.OfferingFacilityBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`offeringFacilityList { ${inner} }`);
    return this;
  }

  offeringIncludeList(b?:(q:Builders.OfferingIncludeBuilder)=>void){
    if(this.depth>=5||this.v.has('offeringIncludeList'))return this;
    this.v.add('offeringIncludeList');
    const n=new Builders.OfferingIncludeBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`offeringIncludeList { ${inner} }`);
    return this;
  }

  offeringItemList(b?:(q:Builders.OfferingItemBuilder)=>void){
    if(this.depth>=5||this.v.has('offeringItemList'))return this;
    this.v.add('offeringItemList');
    const n=new Builders.OfferingItemBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`offeringItemList { ${inner} }`);
    return this;
  }

  offeringMilestoneList(b?:(q:Builders.OfferingMilestoneBuilder)=>void){
    if(this.depth>=5||this.v.has('offeringMilestoneList'))return this;
    this.v.add('offeringMilestoneList');
    const n=new Builders.OfferingMilestoneBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`offeringMilestoneList { ${inner} }`);
    return this;
  }

  offeringPackageList(b?:(q:Builders.OfferingPackageBuilder)=>void){
    if(this.depth>=5||this.v.has('offeringPackageList'))return this;
    this.v.add('offeringPackageList');
    const n=new Builders.OfferingPackageBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`offeringPackageList { ${inner} }`);
    return this;
  }

  offeringPortfolioList(b?:(q:Builders.OfferingPortfolioBuilder)=>void){
    if(this.depth>=5||this.v.has('offeringPortfolioList'))return this;
    this.v.add('offeringPortfolioList');
    const n=new Builders.OfferingPortfolioBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`offeringPortfolioList { ${inner} }`);
    return this;
  }

  offeringSessionList(b?:(q:Builders.OfferingSessionBuilder)=>void){
    if(this.depth>=5||this.v.has('offeringSessionList'))return this;
    this.v.add('offeringSessionList');
    const n=new Builders.OfferingSessionBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`offeringSessionList { ${inner} }`);
    return this;
  }

  offeringSlotList(b?:(q:Builders.OfferingSlotBuilder)=>void){
    if(this.depth>=5||this.v.has('offeringSlotList'))return this;
    this.v.add('offeringSlotList');
    const n=new Builders.OfferingSlotBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`offeringSlotList { ${inner} }`);
    return this;
  }

  packageItemList(b?:(q:Builders.PackageItemBuilder)=>void){
    if(this.depth>=5||this.v.has('packageItemList'))return this;
    this.v.add('packageItemList');
    const n=new Builders.PackageItemBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`packageItemList { ${inner} }`);
    return this;
  }

  resaleList(b?:(q:Builders.ResaleBuilder)=>void){
    if(this.depth>=5||this.v.has('resaleList'))return this;
    this.v.add('resaleList');
    const n=new Builders.ResaleBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`resaleList { ${inner} }`);
    return this;
  }

  resaleTermList(b?:(q:Builders.ResaleTermBuilder)=>void){
    if(this.depth>=5||this.v.has('resaleTermList'))return this;
    this.v.add('resaleTermList');
    const n=new Builders.ResaleTermBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`resaleTermList { ${inner} }`);
    return this;
  }

  reviewList(b?:(q:Builders.ReviewBuilder)=>void){
    if(this.depth>=5||this.v.has('reviewList'))return this;
    this.v.add('reviewList');
    const n=new Builders.ReviewBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`reviewList { ${inner} }`);
    return this;
  }

  slotOptionList(b?:(q:Builders.SlotOptionBuilder)=>void){
    if(this.depth>=5||this.v.has('slotOptionList'))return this;
    this.v.add('slotOptionList');
    const n=new Builders.SlotOptionBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`slotOptionList { ${inner} }`);
    return this;
  }

  waitlistList(b?:(q:Builders.WaitlistBuilder)=>void){
    if(this.depth>=5||this.v.has('waitlistList'))return this;
    this.v.add('waitlistList');
    const n=new Builders.WaitlistBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`waitlistList { ${inner} }`);
    return this;
  }

  reverseBlockedDate(b?:(q:Builders.BlockedDateBuilder)=>void){
    const n=new Builders.BlockedDateBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`blockedDateList { ${inner} }`);
    return this;
  }

  reverseBookingPackage(b?:(q:Builders.BookingPackageBuilder)=>void){
    const n=new Builders.BookingPackageBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`bookingPackageList { ${inner} }`);
    return this;
  }

  reverseMenuCourse(b?:(q:Builders.MenuCourseBuilder)=>void){
    const n=new Builders.MenuCourseBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`menuCourseList { ${inner} }`);
    return this;
  }

  reverseOfferingAddon(b?:(q:Builders.OfferingAddonBuilder)=>void){
    const n=new Builders.OfferingAddonBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`offeringAddonList { ${inner} }`);
    return this;
  }

  reverseOfferingFacility(b?:(q:Builders.OfferingFacilityBuilder)=>void){
    const n=new Builders.OfferingFacilityBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`offeringFacilityList { ${inner} }`);
    return this;
  }

  reverseOfferingInclude(b?:(q:Builders.OfferingIncludeBuilder)=>void){
    const n=new Builders.OfferingIncludeBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`offeringIncludeList { ${inner} }`);
    return this;
  }

  reverseOfferingItem(b?:(q:Builders.OfferingItemBuilder)=>void){
    const n=new Builders.OfferingItemBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`offeringItemList { ${inner} }`);
    return this;
  }

  reverseOfferingMilestone(b?:(q:Builders.OfferingMilestoneBuilder)=>void){
    const n=new Builders.OfferingMilestoneBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`offeringMilestoneList { ${inner} }`);
    return this;
  }

  reverseOfferingPackage(b?:(q:Builders.OfferingPackageBuilder)=>void){
    const n=new Builders.OfferingPackageBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`offeringPackageList { ${inner} }`);
    return this;
  }

  reverseOfferingPortfolio(b?:(q:Builders.OfferingPortfolioBuilder)=>void){
    const n=new Builders.OfferingPortfolioBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`offeringPortfolioList { ${inner} }`);
    return this;
  }

  reverseOfferingSession(b?:(q:Builders.OfferingSessionBuilder)=>void){
    const n=new Builders.OfferingSessionBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`offeringSessionList { ${inner} }`);
    return this;
  }

  reverseOfferingSlot(b?:(q:Builders.OfferingSlotBuilder)=>void){
    const n=new Builders.OfferingSlotBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`offeringSlotList { ${inner} }`);
    return this;
  }

  reversePackageItem(b?:(q:Builders.PackageItemBuilder)=>void){
    const n=new Builders.PackageItemBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`packageItemList { ${inner} }`);
    return this;
  }

  reverseResale(b?:(q:Builders.ResaleBuilder)=>void){
    const n=new Builders.ResaleBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`resaleList { ${inner} }`);
    return this;
  }

  reverseResaleTerm(b?:(q:Builders.ResaleTermBuilder)=>void){
    const n=new Builders.ResaleTermBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`resaleTermList { ${inner} }`);
    return this;
  }

  reverseReview(b?:(q:Builders.ReviewBuilder)=>void){
    const n=new Builders.ReviewBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`reviewList { ${inner} }`);
    return this;
  }

  reverseSlotOption(b?:(q:Builders.SlotOptionBuilder)=>void){
    const n=new Builders.SlotOptionBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`slotOptionList { ${inner} }`);
    return this;
  }

  reverseWaitlist(b?:(q:Builders.WaitlistBuilder)=>void){
    const n=new Builders.WaitlistBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`waitlistList { ${inner} }`);
    return this;
  }
}
